import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="enforce-selection"
export default class extends Controller {
  static targets = ["input", "button"]
  
  connect() {
    this.reset(null)
  }

  reset(_) {
    if (this.inputTargets.some((el) => el.checked)) {
      this.buttonTarget.disabled = false
      this.buttonTarget.title = ''
    } else {
      this.buttonTarget.disabled = "disabled"
      this.buttonTarget.title = 'Merci de sélectionner un article à ajouter'
    }
  }
}
